/* ==========================================================================
   Koolseed — Koleksiyon filtreleri
   Filtre değişince yalnızca sonuç bölümü yeniden çizilir; URL geçmişe
   yazılır, böylece geri tuşu ve bağlantı paylaşımı çalışır.
   JS yoksa form normal gönderim yapar (noscript butonu).
   ========================================================================== */

(function () {
  'use strict';

  class KsFacets extends HTMLElement {
    connectedCallback() {
      this.results = document.querySelector('[data-collection-results]');
      if (!this.results) return;

      this.apply = window.KS.debounce(this.submit.bind(this), 350);

      // Dinleyiciler forma değil, bileşenin kendisine bağlı: çubuk her
      // filtrelemeden sonra yeniden çiziliyor, formun kendisi değişiyor.
      this.addEventListener('change', (event) => {
        if (!event.target.closest('.ks-facets__form')) return;
        // Sayısal alanlar yazarken her tuşta istek atmasın diye debounce'lu.
        if (event.target.type === 'number') this.apply();
        else this.submit();
      });
      this.addEventListener('input', (event) => {
        if (!event.target.closest('.ks-facets__form')) return;
        if (event.target.type === 'number') this.apply();
      });
      this.addEventListener('submit', (event) => {
        event.preventDefault();
        this.submit();
      });

      window.addEventListener('popstate', () => this.render(window.location.search, false));

      // "Daha Fazla Göster" sonuç bölümünde, bu bileşenin dışında duruyor.
      this.results.addEventListener('click', (event) => {
        const button = event.target.closest('[data-load-more]');
        if (button) this.loadMore(button);
      });

      // Sayfa indirim sıralamasıyla açıldıysa seçimi geri yükle ve uygula.
      if (this.discountWanted()) {
        const select = this.querySelector('[data-ks-sort]');
        if (select) select.value = 'ks-discount';
        this.sortByDiscount();
      }
    }

    get form() {
      return this.querySelector('.ks-facets__form');
    }

    /* ---- "İndirim Oranı" ------------------------------------------------
       Shopify'da indirim yüzdesine göre sıralama yok. Seçim URL'de
       ks_sort=discount olarak taşınır (Shopify bu parametreyi yok sayar) ve
       liste burada, kartların data-discount değerine göre diziliyor.
       Sayfalama varsa yalnızca açık sayfayı diziyor — bunu gizlemiyoruz. */
    discountWanted(search) {
      const q = search === undefined ? window.location.search : search;
      return new URLSearchParams(q).get('ks_sort') === 'discount';
    }

    /* Tükenenler her zaman sonda kalsın; indirim sıralaması iki grubun
       kendi içinde çalışsın. Array.sort kararlı olduğu için eşit puanlı
       kartların sunucudan gelen sırası bozulmuyor. */
    sortByDiscount() {
      const grid = this.results.querySelector('.ks-pgrid');
      if (!grid) return;
      Array.from(grid.children)
        .sort((a, b) => {
          const stock = (a.dataset.available === 'false') - (b.dataset.available === 'false');
          if (stock !== 0) return stock;
          return Number(b.dataset.discount || 0) - Number(a.dataset.discount || 0);
        })
        .forEach((card) => grid.appendChild(card));
    }

    /* ---- "Daha Fazla Göster" --------------------------------------------
       Sonraki sayfayı getirip kartları mevcut ızgaraya ekliyor. Buton kendi
       "sonraki" adresini getirilen sayfadan tazeliyor; sayfa kalmayınca
       kayboluyor. Yeni gelen tükenmiş ürünler listenin sonuna diziliyor. */
    async loadMore(button) {
      const next = button.dataset.next;
      if (!next || button.classList.contains('is-loading')) return;

      button.classList.add('is-loading');
      try {
        const response = await fetch(next);
        if (!response.ok) throw new Error('load more failed');
        const html = await response.text();

        const grid = this.results.querySelector('.ks-pgrid');
        const freshGrid = window.KS.extract(html, '.ks-pgrid');
        if (grid && freshGrid) {
          Array.from(freshGrid.children).forEach((card) => grid.appendChild(card));
        }

        const freshButton = window.KS.extract(html, '[data-load-more]');
        const note = this.results.querySelector('.ks-coll__more-note');
        const freshNote = window.KS.extract(html, '.ks-coll__more-note');
        if (freshButton && freshButton.dataset.next) {
          button.dataset.next = freshButton.dataset.next;
          if (note && freshNote) note.innerHTML = freshNote.innerHTML;
        } else {
          const wrap = button.closest('[data-load-more-wrap]');
          if (wrap) wrap.remove();
        }

        this.reorderSoldOut();
        if (this.discountWanted()) this.sortByDiscount();
      } catch (error) {
        // Ağ hatasında normal sayfalamaya düş.
        window.location.href = next;
      } finally {
        button.classList.remove('is-loading');
      }
    }

    reorderSoldOut() {
      const grid = this.results.querySelector('.ks-pgrid');
      if (!grid) return;
      Array.from(grid.children)
        .filter((card) => card.dataset.available === 'false')
        .forEach((card) => grid.appendChild(card));
    }

    buildQuery() {
      const data = new FormData(this.form);
      const params = new URLSearchParams();
      data.forEach((value, key) => {
        if (String(value).trim() === '') return;
        if (key === 'sort_by' && value === 'ks-discount') {
          // Sunucuya gönderilmez; sıralama tarayıcıda yapılıyor.
          params.append('ks_sort', 'discount');
          return;
        }
        params.append(key, value);
      });
      return params.toString();
    }

    submit() {
      const query = this.buildQuery();
      this.render(query ? `?${query}` : '', true);
    }

    async render(search, pushState) {
      const url = this.dataset.url + search;
      this.results.setAttribute('aria-busy', 'true');
      this.results.classList.add('is-busy');

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('facets failed');

        const html = await response.text();
        const fresh = window.KS.extract(html, '[data-collection-results]');
        if (fresh) this.results.innerHTML = fresh.innerHTML;

        // Filtre çubuğundaki sayılar da güncellenmeli (0 olanlar pasifleşir).
        const freshFacets = window.KS.extract(html, '.ks-facets__bar');
        const currentFacets = this.querySelector('.ks-facets__bar');
        if (freshFacets && currentFacets) {
          const openGroups = Array.from(currentFacets.querySelectorAll('details'))
            .map((d) => d.open);
          currentFacets.innerHTML = freshFacets.innerHTML;
          // Açık paneller kapanmasın — kullanıcı seçim yapmaya devam ediyor.
          currentFacets.querySelectorAll('details').forEach((d, i) => {
            if (openGroups[i]) d.open = true;
          });
        }

        // Yeniden çizilen çubukta seçim kaybolmasın.
        if (this.discountWanted(search)) {
          const select = this.querySelector('[data-ks-sort]');
          if (select) select.value = 'ks-discount';
          this.sortByDiscount();
        }

        if (pushState) window.history.pushState({}, '', url);
      } catch (error) {
        // Ağ hatasında normal gezinmeye düş.
        window.location.href = url;
      } finally {
        this.results.setAttribute('aria-busy', 'false');
        this.results.classList.remove('is-busy');
      }
    }
  }

  if (!customElements.get('ks-facets')) customElements.define('ks-facets', KsFacets);
})();
